export const HostLobbyBreakdownSteps = {
  first: 1071,
  second: 865,
  third: 721,
};
